<div class="cm-container">
    <cm-infinite-list listType="table" [count]="$totalCount()" [intersectionStatusChange]="$pageFilledStatusChange()" class="cm-items-list">
        <cm-list-info cm-list-header [parentList]="this" [count]="$totalCount()"></cm-list-info>
        @if ($items().length !== 0) {
            <div class="cm-jobs-table">
                <cm-table-cell class="cm-first-column" [header]="true"> ID </cm-table-cell>
                <cm-table-cell [centered]="true" [header]="true"> State </cm-table-cell>
                <cm-table-cell [header]="true"> Name </cm-table-cell>
                <cm-table-cell [centered]="true" [header]="true"> Priority </cm-table-cell>
                <cm-table-cell [centered]="true" [header]="true"> Action </cm-table-cell>
                <cm-table-cell [header]="true"> Created by </cm-table-cell>
                <cm-table-cell [header]="true"> Created </cm-table-cell>
                <cm-table-cell [header]="true"> Started </cm-table-cell>
                <cm-table-cell [header]="true"> Organization </cm-table-cell>
                <cm-table-cell [header]="true"> Message </cm-table-cell>
                @for (row of $items(); track row.trackId) {
                    <div class="cm-ruler"></div>
                    <div class="cm-table-row" (click)="rowClicked(row.data)">
                        <cm-table-cell [item]="row">
                            <span class="cm-id-cell">
                                <span class="cm-id cm-first-column">{{ row.data?.legacyId }}</span>
                                <cm-copy-id-button [value]="row.data?.legacyId"></cm-copy-id-button>
                            </span>
                        </cm-table-cell>
                        <cm-table-cell [item]="row" [centered]="true">
                            <div class="cm-state-cell">
                                <cm-job-thumbnail
                                    [job]="row.data"
                                    [progress]="
                                        row.data?.state === JobState.Running || row.data?.state === JobState.Runnable ? (row.data?.progress ?? null) : null
                                    "
                                ></cm-job-thumbnail>
                                @if (row.data?.discarded) {
                                    <!-- A compact × badge over the status icon; the tooltip names it "Discarded"
                                         so the meaning stays clear without widening the narrow state column. -->
                                    <span
                                        class="cm-discarded-chip"
                                        aria-label="Discarded"
                                        [matTooltip]="'Discarded ' + (row.data?.discarded | cmTimeAgo) + ' — retired from its slot, kept for reference'"
                                    >
                                        <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M5.5 5.5l5 5M10.5 5.5l-5 5" /></svg>
                                    </span>
                                }
                            </div>
                        </cm-table-cell>
                        <cm-table-cell [item]="row">
                            <cm-overflowable-text>
                                {{ row.data?.name ?? "-" }}
                            </cm-overflowable-text>
                        </cm-table-cell>
                        <cm-table-cell [item]="row" [centered]="true">
                            @if (row.data; as data) {
                                <!-- Init too: a job waits there while the job processing is saturated, which is exactly
                                     when an important one needs to jump ahead of a flood. Only finished jobs have no
                                     priority worth setting. -->
                                @if (data.state === JobState.Init || data.state === JobState.Runnable || data.state === JobState.Running) {
                                    @if (data.priority > 0) {
                                        <button
                                            mat-button
                                            color="accent"
                                            (click)="$event.stopPropagation(); togglePriority(data, false)"
                                            matTooltip="High priority"
                                        >
                                            <i [class]="jobPriorityIconClass(data)"></i>
                                            <span class="cm-priority-value">{{ data.priority }}</span>
                                        </button>
                                    } @else if (data.priority < 0) {
                                        <!-- Deliberately deprioritized (a negative default on the owning user/org). Clicking
                                             promotes this one job to high; toggling back restores the negative default rather
                                             than zeroing it (resetJobPriority), so the penalty survives a round trip. -->
                                        <button
                                            mat-button
                                            color="warn"
                                            (click)="$event.stopPropagation(); togglePriority(data, true)"
                                            matTooltip="Low priority"
                                        >
                                            <i [class]="jobPriorityIconClass(data)"></i>
                                            <span class="cm-priority-value">{{ data.priority }}</span>
                                        </button>
                                    } @else {
                                        <button
                                            mat-button
                                            color="primary"
                                            (click)="$event.stopPropagation(); togglePriority(data, true)"
                                            matTooltip="Default priority"
                                        >
                                            <i [class]="jobPriorityIconClass(data)"></i>
                                        </button>
                                    }
                                }
                            }
                        </cm-table-cell>
                        <cm-table-cell [item]="row" [centered]="true">
                            @if (row.data; as data) {
                                @switch (data.state) {
                                    @case (JobState.Running) {
                                        <button mat-button color="primary" (click)="$event.stopPropagation(); cancelJob(data)">Cancel</button>
                                    }
                                    @case (JobState.Runnable) {
                                        <button mat-button color="primary" (click)="$event.stopPropagation(); cancelJob(data)">Cancel</button>
                                    }
                                    @case (JobState.Complete) {}
                                    @case (JobState.Init) {
                                        @if (can.$to().update.job() && !data.discarded) {
                                            <button mat-button color="primary" (click)="$event.stopPropagation(); restartJob(data)">Start</button>
                                        }
                                    }
                                    @default {
                                        <!-- A discarded job is retired for good and cannot be restarted, so no action is offered. -->
                                        @if (can.$to().update.job() && !data.discarded) {
                                            <button mat-button color="primary" (click)="$event.stopPropagation(); restartJob(data)">Restart</button>
                                        }
                                    }
                                }
                            }
                        </cm-table-cell>
                        <cm-table-cell [item]="row">
                            <cm-user-thumbnail [user]="row.data?.createdBy"></cm-user-thumbnail>
                            &nbsp;
                            {{ row.data?.createdBy?.name }}
                        </cm-table-cell>
                        <cm-table-cell [item]="row" [matTooltip]="formatForDisplay(row.data?.createdAt, {shorten: false})">
                            <div class="cm-date-cell">
                                {{ row.data?.createdAt ? (row.data?.createdAt | cmTimeAgo) : "-" }}
                            </div>
                        </cm-table-cell>
                        <cm-table-cell [item]="row" [matTooltip]="formatForDisplay(row.data?.started, {shorten: false})">
                            <div class="cm-date-cell">
                                {{ row.data?.started ? (row.data?.started | cmTimeAgo) : "-" }}
                            </div>
                        </cm-table-cell>
                        <cm-table-cell [item]="row">
                            <cm-overflowable-text>
                                {{ row.data?.organization?.name }}
                            </cm-overflowable-text>
                        </cm-table-cell>
                        <cm-table-cell [item]="row">
                            <cm-overflowable-text>
                                {{ row.data?.message }}
                            </cm-overflowable-text>
                        </cm-table-cell>
                    </div>
                }
            </div>
        }
    </cm-infinite-list>
</div>
